// import { Box, Container, ThemeProvider, CssBaseline } from "@mui/material";
// import { ATSProvider } from "../context/ATSContext";
// import { premiumTheme } from "../theme";
// import Header from "../components/Header";

// const ATSLayout = ({ children }) => {
//   return (
//     <ThemeProvider theme={premiumTheme}>
//       <CssBaseline /> {/* applies body gradient */}
//       <ATSProvider>
//         <Box
//           sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}
//         >
//           <Header /> {/* pure black, gold accents */}
//           <Container
//             maxWidth="xl"
//             sx={{
//               flex: 1,
//               py: 4,
//               px: { xs: 2, sm: 3, md: 4 },
//             }}
//           >
//             {children}
//           </Container>
//         </Box>
//       </ATSProvider>
//     </ThemeProvider>
//   );
// };

// export default ATSLayout;
// layouts/ATSLayout.js
import { useState } from "react";
import { Box, Container, ThemeProvider, CssBaseline } from "@mui/material";
import { ATSProvider } from "../context/ATSContext";
import { premiumTheme } from "../theme";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import ActingAsBar from "../components/ActingAsBar";

const ATSLayout = ({ children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => setMobileOpen(!mobileOpen);

  return (
    <ThemeProvider theme={premiumTheme}>
      <CssBaseline />
      <ATSProvider>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100vh", // full viewport height
            overflow: "hidden", // prevent global scroll
          }}
        >
          {/* Outside the scrolling area on purpose. If Kumudu is looking at a
              customer's data, that fact must be on screen on every page and
              must not scroll away. */}
          <ActingAsBar />
          <Header onMenuClick={handleDrawerToggle} />
          <Box
            sx={{
              display: "flex",
              flex: 1,
              minHeight: 0, // allows children to shrink/scroll properly
              overflow: "hidden",
            }}
          >
            <Sidebar mobileOpen={mobileOpen} onClose={handleDrawerToggle} />
            <Box
              component="main"
              sx={{
                flexGrow: 1,
                overflowY: "auto", // main content scrolls
                bgcolor: "transparent",

                p: { xs: 1, sm: 1.25 },
              }}
            >
              {/* maxWidth={false}, not "xl".
                  "xl" caps the content at 1536px and centres it, which on a wide
                  monitor put a band of dead space down each side of a candidate
                  table that had columns to spare — the one screen in here that
                  wants every pixel it can get. Nothing on these pages is a
                  reading column that needs a measure. */}
              <Container maxWidth={false} disableGutters sx={{ px: 0 }}>
                {children}
              </Container>
            </Box>
          </Box>
        </Box>
      </ATSProvider>
    </ThemeProvider>
  );
};

export default ATSLayout;
